import { render, staticRenderFns } from "./TotalPoints.vue?vue&type=template&id=14763891&"
import script from "./TotalPoints.vue?vue&type=script&lang=js&"
export * from "./TotalPoints.vue?vue&type=script&lang=js&"
import style0 from "./TotalPoints.vue?vue&type=style&index=0&id=14763891&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports